<template>
  <div>
    <v-card class="mx-auto docs-card" color="white" width="100%" elevation="0">
      <!-- Versión Desktop -->
      <template>
        <!-- Card title si NO está abierto -->
        <v-card-title
          v-if="!openAll"
          class="desktop-title"
          @click="handleTitleClick"
        >
          <v-icon
            class="email-icon theme--light"
            :size="40"
            color="#b11f1f"
            aria-label="Docs icon"
          >
            mdi-file-document
          </v-icon>
        </v-card-title>

        <!-- Card title si SÍ está abierto -->
        <v-card-title v-else class="desktop-title-open">
          <v-row no-gutters>
            <!-- Ícono y título -->
            <v-col
              cols="10"
              class="d-flex align-center"
              @click="handleTitleClick"
            >
              <v-row align="center" no-gutters>
                <v-col cols="auto">
                  <v-icon
                    class="email-icon theme--light"
                    :size="25"
                    color="#b11f1f"
                    aria-label="Docs icon"
                  >
                    mdi-file-document
                  </v-icon>
                </v-col>
                <v-col cols="auto">
                  <span class="docs-title">Docs</span>
                </v-col>
              </v-row>
            </v-col>

            <!-- Ícono “Agregar documento” -->
            <v-col
              v-if="canEdit"
              cols="2"
              class="d-flex justify-end align-center"
              @click="OpenDialogCreateDocument = true"
            >
              <v-icon :size="25" color="#b11f1f" aria-label="Add icon">
                mdi-plus-circle-outline
              </v-icon>
            </v-col>
          </v-row>
        </v-card-title>

        <!-- Contenido si NO está abierto -->
        <v-card-text v-if="!openAll" class="text-center">
          <span class="docs-text-title">Docs</span>
        </v-card-text>

        <!-- Contenido si SÍ está abierto -->
        <v-card-text v-else>
          <div v-if="docs.length > 0">
            <!-- Lista de los primeros 3 documentos -->
            <div class="docs-list-container">
              <v-row
                v-for="(doc, idx) in firstThreeDocs"
                :key="idx"
                class="align-center"
              >
                <v-col cols="8" class="d-flex align-center">
                  <h4
                    :style="
                      tieneError(doc.urlBucket)
                        ? { color: 'red', fontWeight: 'bold' }
                        : {}
                    "
                  >
                    {{ doc.nombre }}
                  </h4>
                </v-col>

                <v-col cols="4" class="text-end">
                  <v-icon
                    color="#b11f1f"
                    size="26"
                    style="cursor: pointer;"
                    @click="OpenDialogShowDocs = true"
                  >
                    mdi-eye-outline
                  </v-icon>
                </v-col>
              </v-row>
            </div>

            <!-- Botón “Ver más” -->
            <div class="text-center mt-2">
              <v-btn
                elevation="0"
                color="white"
                @click="OpenDialogShowDocs = true"
              >
                <span style="color:#0070C0">Ver más</span>
              </v-btn>
            </div>
          </div>

          <!-- Si no hay documentos -->
          <div v-else class="docs-empty-container text-center">
            <v-row>
              <v-col cols="12">
                <h3>No hay nada por el momento</h3>
              </v-col>
            </v-row>
          </div>
        </v-card-text>
      </template>
    </v-card>

    <!-- Dialog para crear documentos -->
    <CreateDocsDialog
      :OpenDialogCreateDocument="OpenDialogCreateDocument"
      :routesConfigDocsCard="routesConfigDocsCard"
      @closeModal="OpenDialogCreateDocument = false"
      @success="getData"
    />

    <!-- Dialog para mostrar documentos -->
    <ShowDocumentsDialog
      :docs="docs"
      :OpenDialogShowDocs="OpenDialogShowDocs"
      @closeModal="OpenDialogShowDocs = false"
      @openCreateModal="OpenDialogCreateDocument = true"
    />
  </div>
</template>


<script>
import CreateDocsDialog from "../dialogs/CreateDocsDialog.vue";
import ShowDocumentsDialog from "../dialogs/ShowDocsDialog.vue";

export default {
  name: "CommonCardDocs",
  components: {
    CreateDocsDialog,
    ShowDocumentsDialog,
  },
  props: {
    docs: {
      type: Array,
      default: () => [],
    },
    openAll: {
      type: Boolean,
      default: false,
    },
    canEdit: {
      type: Boolean,
      default: true,
    },
    routesConfigDocsCard: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      OpenDialogCreateDocument: false,
      OpenDialogShowDocs: false,
      showStatus: false,
    };
  },
  computed: {
    firstThreeDocs() {
      return this.docs?.slice(0, 3) || [];
    },
  },
  watch: {
    openAll(val) {
      this.showStatus = val;
    },
  },
  methods: {
    getData() {
      this.OpenDialogCreateDocument = false;
      this.$emit("getData");
    },
    showAll() {
      this.$emit("showAll", !this.showStatus);
    },
    toggleDocumentsPanel() {
      this.$emit("toggleDocumentsPanel");
    },
    handleTitleClick() {
      this.showAll();
      this.toggleDocumentsPanel();
    },
    tieneError(url) {
      return typeof url === "string" && /^error/i.test(url.trim());
    },
  },
};
</script>


<style scoped>
.docs-card {
  border-radius: 20px;
  box-shadow: 0px 3px 3px -2px rgba(0, 0, 0, 0.2),
    0px 3px 4px 0px rgba(0, 0, 0, 0.14), 0px 1px 8px 0px rgba(0, 0, 0, 0.12) !important;
}
.desktop-title,
.desktop-title-open {
  justify-content: center;
  cursor: pointer;
  min-height: 60px;
}
.docs-icon {
  width: 40px;
  height: auto;
}
.docs-title,
.docs-text-title {
  font-weight: bold;
  font-size: 1.25rem;
  letter-spacing: 0.0125em;
  line-height: 2rem;
  word-break: break-all;
  color: rgba(0, 0, 0, 0.87);
  margin-left: 8px;
}
.docs-list-container {
  height: 180px !important;
}
.docs-empty-container {
  height: 216px !important;
}
</style>
